import React from 'react';
import { TabPills } from '@components/common';
import { Button, ModalBox, useModalContext } from '@fourthwall/components';
import { ExistingPodcastFields } from './components/ExistingPodcastFields/ExistingPodcastFields';
import { NewPodcastFields } from './components/NewPodcastFields/NewPodcastFields';
import { useNewPodcastModalContext } from './hooks/useNewPodcastModalContext';
import { NewPodcastModalProvider } from './providers/NewPodcastModalProvider';
const NewPodcastModalContent = () => {
    const modal = useModalContext();
    const { tab, setTab, existingPodcastForm, newPodcastForm, preview, isLoading } = useNewPodcastModalContext();
    return (React.createElement(ModalBox, { title: "Where do you want your members-only audio to appear on Spotify?", buttons: [
            React.createElement(Button, { label: "Cancel", onClick: modal.close }),
            React.createElement(Button, { label: "Continue", appearance: "primary", loading: isLoading, onClick: () => {
                    if (tab === 'existing') {
                        if (preview.error)
                            return;
                        if (preview.data?.hostedOnSpotify)
                            return;
                        existingPodcastForm.submitForm();
                    }
                    else {
                        newPodcastForm.submitForm();
                    }
                } }),
        ], onClose: modal.close },
        React.createElement(TabPills, { options: [
                { label: ' Add to your existing podcast', value: 'existing' },
                { label: 'Create a new podcast', value: 'new' },
            ], value: tab, onChange: isLoading ? () => { } : setTab }),
        tab === 'existing' ? React.createElement(ExistingPodcastFields, null) : React.createElement(NewPodcastFields, null)));
};
export const NewPodcastModal = () => (React.createElement(NewPodcastModalProvider, null,
    React.createElement(NewPodcastModalContent, null)));
